import AdminOrderPromo from '../../../promo/AdminOrderPromo';
import React, { useEffect, useRef } from 'react';
import PromPaymentIcon from '../../../shared/PromPaymentIcon';
import PromPayByPartsIcon from '../../../shared/PromPayByPartsIcon';
import OrderItemsList from './OrderItemsList';
import SelectedOrderItemsDropdown from './SelectedOrderItemsDropdown';
import DeliveryDataCard from './DeliveryDataCard';
import AttachPaymentToOrder from '../payment/AttachPaymentToOrder';
import AdminOrderStatusAndPaymentMobile from './AdminOrderStatusAndPaymentMobile';
import { filterPaymentTypesForOrder } from '../../../../utils/adminOrderService';
import { isScannerPickButtonAvailable } from './adminOrderScannerPickUtils';
import { orderItemKey } from '../../../../utils/orderItemKeys';
import '../../../../styles/admin-order-items-mobile.css';

function MobilePickedScannerLabel() {
  return (
    <span
      className='d-inline-flex align-items-center text-dark'
      style={{
        gap: '0.45rem',
        fontSize: '0.95rem',
        fontWeight: 700,
        letterSpacing: '0.01em',
      }}
    >
      <i className='bi bi-check-square-fill' style={{ fontSize: '1.08rem' }} aria-hidden='true' />
      Зібрано зі сканером
    </span>
  );
}

const AdminOrderMobileView = ({
  order,
  onPromoChanged,
  paymentRefreshKey,
  orderStatusesEnum,
  paymentTypesEnum,
  paymentStatusesEnum,
  getOrderInfo,
  handleOrderStatusChange,
  handlePaymentTypeChange,
  handlePaymentStatusChange,
  renderGenerateMessageToClipboardIcon,
  renderGeneratePreorderMessageToClipboardIcon,
  renderGeneratePreorderSoonMessageToClipboardIcon,
  renderGenerateDeliveryConfirmationMessageToClipboardIcon,
  setModalImage,
  handleEditProductOrderButtonClick,
  renderUserComment,
  renderAdminComment,
  handleEditDeliveryInfoButtonClick,
  copyToClipboard,
  detachOrderFromUser,
  disableButtons,
  onOpenCreateShipmentModal,
  onOpenDeleteShipmentModal,
  onOpenScannerPick,
  selectedOrderItemKeys,
  onToggleSelect,
  onSelectAll,
  onClearSelection,
  showSelectedDropdown,
  onToggleSelectedDropdown,
  onCloseSelectedDropdown,
  onOpenBulkDiscount,
  onOpenBulkDiscountForAll,
  onMoveSelected,
  onSplitSelected,
  onExportExcel,
  onExportInvoice,
}) => {
  const selectAllRef = useRef(null);
  const selectedCount = (order.orderItems || []).filter(item => selectedOrderItemKeys?.includes(orderItemKey(item))).length;
  const allSelected = selectedCount > 0 && selectedCount === order.orderItems?.length;

  useEffect(() => {
    if (selectAllRef.current) selectAllRef.current.indeterminate = selectedCount > 0 && !allSelected;
  }, [selectedCount, allSelected]);

  const renderComments = () => (
    <>
      {renderUserComment && renderUserComment()}
      {renderAdminComment && renderAdminComment()}
    </>
  );

  return (
    <div className='row'>
      <div className='col-12 p-0'>
        <div className='card'>
          <div className='card-header p-2'>
            <div className='d-flex justify-content-between align-items-start'>
              <div className='d-flex flex-column align-items-start' style={{ minWidth: 0, flex: '1 1 auto', paddingRight: '0.5rem' }}>
                <div className='font-weight-bold d-flex align-items-center flex-wrap'>
                  <span>#{order.orderId}</span>
                  {renderGenerateMessageToClipboardIcon()}
                  {renderGeneratePreorderMessageToClipboardIcon()}
                  {renderGeneratePreorderSoonMessageToClipboardIcon()}
                  {renderGenerateDeliveryConfirmationMessageToClipboardIcon()}
                  {order.promOrderId != null && (
                    <img src="/prom-logo.png" alt="Пром" className="ml-1" title="Замовлення з Пром" style={{ height: '24px', verticalAlign: 'middle' }} />
                  )}
                </div>
                <div className='dropdown mt-1'>
                  <div className='dropdown-toggle' data-toggle='dropdown' aria-expanded='false'>
                    {order.paymentType.databaseValue === 'CREDIT_CARD' && <i className='bi bi-credit-card pr-1' />}
                    {order.paymentType.databaseValue === 'CASH_ON_DELIVERY' && <i className='bi bi-cash-coin pr-1' />}
                    {order.paymentType.databaseValue === 'CASH' && <i className='bi bi-cash pr-1' />}
                    {order.paymentType.databaseValue === 'PROM_PAYMENT' && <PromPaymentIcon />}
                    {order.paymentType.databaseValue === 'PROM_PAY_BY_PARTS' && <PromPayByPartsIcon />}
                    {order.paymentType.adminValue}
                  </div>
                  <div className='dropdown-menu payment-type'>
                    {filterPaymentTypesForOrder(paymentTypesEnum, order)
                      .filter((pt) => pt.adminValue !== order.paymentType.adminValue)
                      .map((paymentType, index) => (
                        <a
                          key={index}
                          className='dropdown-item'
                          onClick={() => handlePaymentTypeChange(order, paymentType, getOrderInfo)}
                        >
                          {paymentType.adminValue}
                        </a>
                      ))}
                  </div>
                </div>
                <span className='text-muted mt-1' style={{ fontSize: '0.8rem' }}>{order.createTime}</span>
              </div>
              <div className='d-flex flex-column align-items-end flex-shrink-0' style={{ maxWidth: '100%' }}>
                <AdminOrderStatusAndPaymentMobile
                  order={order}
                  orderStatusesEnum={orderStatusesEnum}
                  paymentStatusesEnum={paymentStatusesEnum}
                  onPickOrderStatus={(status) =>
                    handleOrderStatusChange(order, status, getOrderInfo)}
                  onPickPaymentStatus={(paymentStatus) =>
                    handlePaymentStatusChange(order, paymentStatus, getOrderInfo)}
                />
              </div>
            </div>
          </div>
          <div className='card-header admin-order-products-header'>
            <div className='admin-order-products-title'>
              <h5>Товари в замовленні</h5>
              <span className='admin-order-products-count'>Позицій: {order.orderItems?.length || 0}</span>
            </div>
            {order.orderItems?.length > 0 && <div className='admin-order-products-controls'>
              <label className='admin-order-products-select-all'>
                <input ref={selectAllRef} type='checkbox' checked={allSelected} onChange={onSelectAll} aria-label='Обрати всі товари' />
                Обрати всі{selectedCount > 0 && <span className='admin-order-products-selected-count'>{selectedCount}</span>}
              </label>
              <SelectedOrderItemsDropdown alignRight compact selectedCount={selectedCount}
                show={showSelectedDropdown} onToggleShow={onToggleSelectedDropdown} onCloseDropdown={onCloseSelectedDropdown}
                onOpenBulkDiscount={onOpenBulkDiscount} onOpenBulkDiscountForAll={onOpenBulkDiscountForAll}
                onMoveSelected={onMoveSelected} onSplitSelected={onSplitSelected}
                onExportExcel={onExportExcel} onExportInvoice={onExportInvoice} onClearSelection={onClearSelection} />
            </div>}
            {order.pickedWithScanner === true && order.orderItems?.length > 0 ? (
              <div className='d-flex justify-content-start mt-0'>
                <MobilePickedScannerLabel />
              </div>
            ) : null}
          </div>
          {order.orderItems != null && (
            <div className='card-body p-0'>
              <OrderItemsList
                order={order}
                variant='mobile'
                setModalImage={setModalImage}
                handleEditClick={handleEditProductOrderButtonClick}
                onOpenScannerPick={onOpenScannerPick}
                selectedOrderItemKeys={selectedOrderItemKeys}
                onToggleSelect={onToggleSelect}
              />
            </div>
          )}
          <div className='card-footer admin-order-totals-footer'>
              <AdminOrderPromo inputId='admin-order-promo-mobile' order={order} onChanged={onPromoChanged || getOrderInfo} />
          </div>
        </div>

        {order.orderItems?.length > 0 &&
        onOpenScannerPick &&
        order.pickedWithScanner !== true &&
        isScannerPickButtonAvailable(order) ? (
          <div className='w-100 mt-1 mb-1 px-0'>
            <button
              type='button'
              className='btn btn-dark btn-block font-weight-bold w-100 d-flex align-items-center justify-content-center border-0 shadow-sm rounded-0'
              style={{
                paddingTop: '0.65rem',
                paddingBottom: '0.65rem',
                fontSize: '1rem',
                gap: '0.45rem',
              }}
              onClick={onOpenScannerPick}
            >
              <i className='bi bi-upc-scan' style={{ fontSize: '1.2rem' }} aria-hidden='true' />
              Зібрати сканером
            </button>
          </div>
        ) : null}

        {order.paymentType?.databaseValue !== 'CASH_ON_DELIVERY' && (
          <div className='col-12 p-0 mb-3 pt-3'>
            <AttachPaymentToOrder
              refreshKey={paymentRefreshKey}
              orderId={order.orderId}
              orderPrice={order.discountedPrice}
              orderPaymentStatus={order.paymentStatus}
              onPaymentAttached={getOrderInfo}
              isMobile
            />
          </div>
        )}

        <DeliveryDataCard
          order={order}
          variant='mobile'
          onEditDelivery={handleEditDeliveryInfoButtonClick}
          copyToClipboard={copyToClipboard}
          detachOrderFromUser={detachOrderFromUser}
          disableButtons={disableButtons}
          onOpenCreateShipmentModal={onOpenCreateShipmentModal}
          onOpenDeleteShipmentModal={onOpenDeleteShipmentModal}
          renderComments={renderComments}
        />
      </div>
    </div>
  );
};

export default AdminOrderMobileView;
